import React from 'react';
import { Feed, Icon, Image } from 'semantic-ui-react';

import { NumArticles } from '../../Popups';
import { BoardLink } from '../../Links';

const Board = ({
  alias,
  cover,
  id,
  numArticles,
  title,
}) => (
  <Feed.Event>
    {
      cover
      && (
        <Feed.Label>
          <Image src={cover} />
        </Feed.Label>
      )
    }
    <Feed.Content>
      <Feed.Summary>
        <BoardLink id={id}>
          <div>
            {title ?? alias}
            {' '}
            (
            {alias}
            )
          </div>
        </BoardLink>
      </Feed.Summary>
      <Feed.Meta>
        <NumArticles>
          <Feed.Like>
            <Icon name="write" />
            {numArticles}
          </Feed.Like>
        </NumArticles>
      </Feed.Meta>
    </Feed.Content>
  </Feed.Event>
);

export default ({ data }) => (
  data.length > 0 ? (
    <Feed size="large">
      {
        data.map((board) => (
          <Board
            alias={board.alias}
            cover={board.cover}
            id={board.id}
            key={board.id}
            numArticles={board.num_articles}
            title={board.title}
          />
        ))
      }
    </Feed>
  ) : null
);
